import { createAction } from "@reduxjs/toolkit";
export var ProcessDataListActionType;
(function (ProcessDataListActionType) {
    ProcessDataListActionType["LOAD_LIST"] = "PROCESS-DATA-LIST/LOAD_LIST";
    ProcessDataListActionType["LOAD_LIST_SUCCESSFUL"] = "PROCESS-DATA-LIST/LOAD_LIST_SUCCESSFUL";
    ProcessDataListActionType["LOAD_LIST_FAILURE"] = "PROCESS-DATA-LIST/LOAD_LIST_FAILURE";
})(ProcessDataListActionType || (ProcessDataListActionType = {}));
export const loadProcessDataList = createAction(ProcessDataListActionType.LOAD_LIST);
export const loadProcessDataListSuccessful = createAction(ProcessDataListActionType.LOAD_LIST_SUCCESSFUL);
export const loadProcessDataListFailure = createAction(ProcessDataListActionType.LOAD_LIST_FAILURE);
